import SignImage from '../../assets/images/sign.png';

export function SignIcon(props: any) {
  return <img src={SignImage} alt="Event icon" {...props} />;
}
